/** 后端统一预订DTO约定的五类业务场景编码。 */
export const BOOKING_SCENES = {
  FIT: 'FIT_BOOKING',
  LONG_STAY: 'LONG_STAY_BOOKING',
  TEAM: 'TEAM_BOOKING',
  WALK_IN: 'WALK_IN',
  EBK: 'EBK_MANUAL_MOVE',
};

/** 各业务场景在弹框、抽屉和独立页签中的默认标题。 */
export const BOOKING_SCENE_TITLES = {
  [BOOKING_SCENES.FIT]: 'commonBook.fitBooking',
  [BOOKING_SCENES.LONG_STAY]: 'commonBook.longStayBooking',
  [BOOKING_SCENES.TEAM]: 'commonBook.teamBooking',
  [BOOKING_SCENES.WALK_IN]: 'commonBook.walkIn',
  [BOOKING_SCENES.EBK]: 'commonBook.ebkManualMove',
};

/**
 * 各预订场景允许使用的入住类型编码。
 * 名称和排序仍由后端字典决定，这里只保留统一页面的场景策略差异。
 */
export const BOOKING_SCENE_STAY_TYPE_VALUES = {
  [BOOKING_SCENES.FIT]: ['fullDay', 'hour', 'selfUse', 'free'],
  [BOOKING_SCENES.LONG_STAY]: ['longTermFullDay'],
  [BOOKING_SCENES.TEAM]: ['team'],
  [BOOKING_SCENES.WALK_IN]: ['fullDay', 'selfUse', 'free', 'hour'],
  [BOOKING_SCENES.EBK]: ['fullDay', 'hour'],
};
